import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";
// import { IoDocumentTextOutline } from "react-icons/io5";
import { TbReportSearch } from "react-icons/tb";
import "../../borrowSystem/Report/ListReports.css"

export function ListReportSupportRequestComponent() {
    return(
        <Container>
            <div className="d-flex flex-wrap justify-content-center align-items-center ">
                
                {/* <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/reports/AllocatedAndSubsidies38"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 4 5 8 และ 9)</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/reports/AllocatedAndSubsidies39"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 6)</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/reports/AllocatedAndSubsidies40"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 7)</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/reports/AllocatedAndSubsidies41"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 11)</p>
                    </Link>
                </div> */}



                {/* ใหม่ */}
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/reports/AllocatedAndSubsidies38"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 4 7 และ 8)</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/reports/AllocatedAndSubsidies42"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 5)</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/reports/AllocatedAndSubsidies40"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 6)</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/reports/AllocatedAndSubsidies39"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 9)</p>
                    </Link>
                </div>
                <div className="d-flex flex-column text-center flex-shrink-1 border border-1 mx-3 my-2 item-report align-items-center justify-content-center">
                    <Link 
                        to="/supporting/reports/AllocatedAndSubsidies41"
                        style={{ textDecoration: "none" }}
                        >
                            <TbReportSearch className="icon-doc"/>
                            <p className="px-3">ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน (สำหรับประกาศข้อ 10)</p>
                    </Link>
                </div>
            </div>
        </Container>
    )
}